import React, { useState } from "react";
import { observer } from "mobx-react-lite";

import styles from "./showMoreButton.module.scss";
import { ChevronDownIcon } from "@fluentui/react-icons-northstar";
import { Button } from "@fluentui/react-northstar";

export interface ShowMoreButtonProps {
    titleShowMore: string | undefined;
    titleHide: string | undefined;
    onClickExpand: () => void;
    onClickHide: () => void;
}

export const ShowMoreButton: React.FC<ShowMoreButtonProps> = observer((props) => {
    const [isExpanded, setIsExpanded] = useState(false);

    return (
        <Button
            iconPosition="after"
            className={styles.showHideButton}
            text
            content={isExpanded ? props.titleHide : props.titleShowMore}
            icon={isExpanded ? <ChevronDownIcon rotate={180} /> : <ChevronDownIcon />}
            onClick={() => {
                const switchingTo = !isExpanded;
                setIsExpanded(switchingTo);
                if (switchingTo) {
                    props.onClickExpand();
                } else {
                    props.onClickHide();
                }
            }}
        />
    );
});
